import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=3c60208c&scoped=true&"
import script from "./LandingLayout.vue?vue&type=script&lang=js&"
export * from "./LandingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60208c",
  null
  
)

export default component.exports